export default __webpack_public_path__ + "static/media/scrabble.fd09ffd6.jpg";